import React from 'react';
import { Provider } from 'react-redux';
import { translate } from '../Services/translation';
import BuyButton from "../Containers/BuyButton.container";
import ProductQuantity from './ProductQuantity';

const ItemScrollProduct = ({ item, index, color, buttonColor }) => {
    const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));

    let hideQuantity = !item.hideQuantityInput ? "" : "hide-quantity";

    const parser = new DOMParser();
    const doc = parser.parseFromString(item.imageHtml, 'text/html');
    const imgElement = doc.querySelector('img'); 
    const altText = imgElement ? imgElement.alt : null; 
    let imageAlt = altText ? altText : item.name;

    return (
        <div className="product" key={index} href={item.url}>
            {item.campaignTag && item.campaignTag.isActive &&
                <a href={item.url} className="campaign-tag" style={{ backgroundColor: item.campaignTag.backgroundColor, width: item.campaignTag.tagSize, boxShadow: item.campaignTag.shadow}}>
                    <div className="campaign-tag__text" style={{ color: item.campaignTag.textColor}} dangerouslySetInnerHTML={{__html: item.campaignTag.text}}>
                    </div>
                </a>
            }
            {item.statusLabel && item.statusLabel.id &&
                <a className="product" key={index} href={item.url}>
                    <span className={`product-list__caption ${item.statusLabel.id}`}>{item.statusLabel.text}</span>
                </a>
            }
            {item.imageHtml ? (
                <a className="product" key={index} href={item.url}>
                    <figure className="product__figure">
                        <img src={item.imageUrl} alt={imageAlt} />
                    </figure>
                </a>
            ) : (<span className="product__image--missing">{translate('product.noproductimage')}</span>)}
            <div className="product__info">
                <a className="product" key={index} href={item.url}>
                    <h3 className="product__name" style={{ color: color }}>{item.name}</h3>
                    <div className="product__price-container" style={{ color: color }}>
                        {item.campaignPrice && (
                            <div className="product__price-campaign">
                                <div className="primary-unit">
                                    {item.campaignPrice}/{item.priceUnit}
                                </div>
                            </div>
                        )}
                        { item.price && (
                            <div className={`product__price ${item.campaignPrice ? 'old-price' : ''}`}>
                                <div className="primary-unit">
                                    {item.price}/{item.priceUnit}
                                </div>
                            </div>
                        )}
                    </div>
                </a>
                {item.showBuyButton ? (
                <>
                    {item.showQuantityField && item.isInStock ? (
                    true ? ( //!item.hasVariants
                        <>
                        <div className={`product__buy-container ${hideQuantity}`}>
                            <Provider store={store}>
                                <ProductQuantity {...{
                                    wholePallet: item.wholePallet,
                                    quantityPerPallet: item.quantityPerPallet,
                                    inputId: item.quantityFieldId,
                                    unit: item.priceUnit,
                                    minimumQuantity: 0.01,
                                    wholePalletMessage: translate('product.wholePallet'),
                                    unitDecimalDigits: item.unitDecimalDigits,
                                    price: item.pricePerPiece,
                                    priceCampaign: item.campaignPricePerPiece,
                                    quantityPerSquareMeter: item.quantityPerSquareMeter,
                                    palletInfo: item.palletInfo,
                                    currency: item.currency,
                                    isFromProductPage: false,
                                    isFromCategoryPage: true,
                                    hasWastage: item.hasWastage,
                                    wastagePercent: item.wastagePercentage, 
                                    wastageInfo: item.wastageInfo
                                }} />
                            </Provider>
                            { item.price && (
                                <div className="product__block-button-wrapper">
                                    <Provider store={store}>
                                        <BuyButton {...{
                                            label: translate('product.buy'), 
                                            articleNumber: item.id, 
                                            quantityFieldId: item.quantityFieldId, 
                                            href: item.url, 
                                            cssClass: `product__buy-button product__block-button ${buttonColor}`,
                                            price: item.price, 
                                            productName: item.name
                                        }} />
                                    </Provider>
                                </div>
                            )}
                        </div>
                        </>
                    ) : (
                        <div className={`product__buy-container ${hideQuantity}`}>
                            <a href={item.url} itemProp="url">
                                <div className={`product__buy-button product__block-button ${buttonColor}`}>
                                    {translate('product.show')}
                                </div>
                            </a>
                        </div>
                    )
                    ) : ""
                    }
                </>
                ) : ""
                }
            </div>
        </div>
    )
}

export default ItemScrollProduct;
